var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorinfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.683,
    height: 8.683,
    viewBox: "0 0 8.683 8.683",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F44336",
    d: "M5.341,1A4.341,4.341,0,1,0,9.683,5.341,4.337,4.337,0,0,0,5.341,1Zm0,1.085a.543.543,0,1,1-.543.543A.544.544,0,0,1,5.341,2.085ZM6.7,8.055H3.985V6.969H4.8V4.663H4.256V3.578H5.884V6.969H6.7Z",
    transform: "translate(-1 -1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorinfo);
export default __webpack_public_path__ + "static/media/errorinfo.eaa14aac83a1e7035bd0e207de299eb4.svg";
export { ForwardRef as ReactComponent };